import request from '@/utils/request'

/**
 * 获取第三方平台密钥列表
 */
export const getOpenAppLists = () => {
    return request({
        url: '/heating/open_app/lists'
    })
}
/**
 * 修改密钥
 */
export const putOpenAppManage = (data) => {
    return request({
        url: '/heating/open_app/manage',
        method: 'PUT',
        data
    })
}

/**
 * 添加密钥
 */
export const addOpenAppManage = (data) => {
    return request({
        url: '/heating/open_app/manage',
        method: 'POST',
        data
    })
}

/**
 * 模块-删除
 */
export const delOpenAppManage = (id) => {
    return request({
        url: '/heating/open_app/manage',
        method: 'DELETE',
        data: {
            id
        }
    })
}
